import React, { useState, useEffect,  forwardRef, useContext} from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../../RootContext";
import { api_url } from "../../authorize";

import MaterialTable from 'material-table';

import {
  Link
} from "react-router-dom";

import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import logo from './../../img/lento_logo.jpg';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '@material-ui/core/Button';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';



const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} fontSize="large"/>),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Reset: forwardRef((props, ref) => <RotateLeftIcon {...props} ref={ref} />)

  };

  // const useStyles = makeStyles({
  //   root: {
  //     background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  //     border: 0,
  //     borderRadius: 3,
  //     boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  //     color: 'white',
  //     height: 48,
  //     padding: '0 30px',
  //   },
  // });

  const theme = createMuiTheme({
    typography: { h6: {fontSize: '1.4em'}},
  });

const useStyles = makeStyles((muiTheme) => ({
  page: {
    minHeight: 'calc(100vh - 72px)',
    padding: '18px 8px 36px',
    boxSizing: 'border-box',
    background: 'radial-gradient(circle at 8% 2%, #EAF8F2 0, transparent 30%), radial-gradient(circle at 92% 0%, #E8F7F6 0, transparent 32%), linear-gradient(180deg, #F9FCFB 0%, #EEF7F4 100%)',
    color: '#18283a',

    [muiTheme.breakpoints.down('sm')]: {
      padding: '20px 14px 34px',
    },
  },
  shell: {
    width: '100%',
    maxWidth: 'none',
    margin: 0,
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 24,
    marginBottom: 22,
    padding: '24px 26px',
    borderRadius: 20,
    background: 'linear-gradient(135deg, #123B5D 0%, #0D6E8A 58%, #169B97 100%)',
    border: '1px solid rgba(255, 255, 255, 0.24)',
    boxShadow: '0 18px 42px rgba(22, 155, 151, 0.18)',

    [muiTheme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: 14,
      padding: '21px 20px',
    },
  },
  eyebrow: {
    margin: 0,
    color: 'rgba(255, 255, 255, 0.82)',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },
  title: {
    margin: '7px 0 0',
    color: '#ffffff',
    fontSize: 32,
    lineHeight: 1.15,
    fontWeight: 800,
    letterSpacing: '-0.035em',

    [muiTheme.breakpoints.down('xs')]: {
      fontSize: 27,
    },
  },
  subtitle: {
    maxWidth: 760,
    margin: '8px 0 0',
    color: 'rgba(255, 255, 255, 0.84)',
    fontSize: 15,
    lineHeight: 1.6,
  },
  headerMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
  },
  metaPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    minHeight: 38,
    padding: '0 14px',
    borderRadius: 999,
    background: 'rgba(255, 255, 255, 0.94)',
    border: '1px solid rgba(255, 255, 255, 0.72)',
    boxShadow: '0 10px 24px rgba(12, 38, 60, 0.18)',
    color: '#69401D',
    fontSize: 13,
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  metaDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: '#2F8580',
    boxShadow: '0 0 0 4px rgba(255, 255, 255, 0.52)',
  },
  card: {
    overflow: 'hidden',
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid #B9DDD2',
    borderTop: '4px solid #0D6E8A',
    boxShadow: '0 20px 52px rgba(27, 154, 146, 0.16)',

    '& .MuiPaper-root': {
      boxShadow: 'none',
      borderRadius: 0,
    },
    '& .MuiToolbar-root': {
      minHeight: 68,
      paddingLeft: 22,
      paddingRight: 18,
      borderBottom: '1px solid #B9DDD2',
      background: 'linear-gradient(90deg, #FFFFFF 0%, #E8F7F6 100%)',
    },
    '& .MuiTable-root': {
      width: '100%',
      minWidth: 0,
      tableLayout: 'auto',
    },
    '& .MuiTableCell-root': {
      boxSizing: 'border-box',
    },
    '& .MuiTableCell-head': {
      padding: '12px 8px',
      background: '#E8F7F6',
      borderTop: '1px solid #E9D2B9',
      borderBottom: '1px solid #E9D2B9',
      color: '#194F47',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
      fontSize: 12.5,
      fontWeight: 700,
      lineHeight: 1.35,
      letterSpacing: '0.01em',
      whiteSpace: 'normal',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'normal',
    },
    '& thead .MuiTableRow-root:first-child .MuiTableCell-head': {
      background: 'linear-gradient(135deg, #17324D 0%, #114E73 52%, #0D6E8A 100%)',
      color: '#ffffff',
      borderColor: 'rgba(255, 255, 255, 0.14)',
    },
    '& thead .MuiTableRow-root:nth-child(2) .MuiTableCell-head': {
      background: 'linear-gradient(90deg, #EAF8F2 0%, #E8F7F6 100%)',
      color: '#194F47',
      borderBottom: '1px solid #B9DDD2',
    },
    '& .MuiTableCell-body': {
      padding: '11px 8px',
      borderBottom: '1px solid #edf1f5',
      color: '#263b50',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
      fontSize: 12.5,
      fontWeight: 500,
      lineHeight: 1.4,
      verticalAlign: 'middle',
      whiteSpace: 'normal',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      overflowWrap: 'anywhere',
    },
    '& .MuiTableCell-head:last-child': {
      paddingLeft: 2,
      paddingRight: 2,
      textAlign: 'center',
    },
    '& .MuiTableCell-body:last-child': {
      paddingLeft: 2,
      paddingRight: 2,
      textAlign: 'center',
    },
    '& .MuiTableCell-body:last-child > div': {
      width: '100%',
      display: 'flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
    },
    '& .MuiTableCell-body:last-child .MuiIconButton-root': {
      margin: 0,
    },
    '& .MuiTableCell-paddingCheckbox': {
      paddingLeft: 4,
      paddingRight: 4,
    },
    '& .MuiIconButton-root': {
      padding: 5,
      color: '#49647d',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18,
    },
    '& .MuiTableBody-root .MuiTableRow-root': {
      transition: 'background-color 140ms ease, box-shadow 140ms ease',
    },
    '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)': {
      backgroundColor: '#F8FCFA',
    },
    '& .MuiTableBody-root .MuiTableRow-root:hover': {
      backgroundColor: '#E8F7F1 !important',
      boxShadow: 'inset 4px 0 0 #0D6E8A',
    },
    '& .MuiInputBase-root': {
      color: '#263b50',
      fontSize: 14,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#0D6E8A',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: '#B66A27',
    },
    '& .MuiTableContainer-root': {
      width: '100%',
      overflowX: 'auto',
    },
    '& .MuiTablePagination-root': {
      borderTop: '1px solid #E9D2B9',
      background: 'linear-gradient(90deg, #FFFFFF 0%, #E8F7F6 100%)',
      color: '#194F47',
    },
    '& .MuiTablePagination-toolbar': {
      minHeight: 62,
    },
    '& .MuiIconButton-root:hover': {
      color: '#248A73',
      background: '#EAF8F2',
    },
  },
  cardIntro: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 18,
    padding: '18px 22px',
    borderBottom: '1px solid #B9DDD2',
    background: 'linear-gradient(105deg, #EAF8F2 0%, #FFFFFF 46%, #E8F7F6 100%)',

    [muiTheme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  cardLabel: {
    margin: 0,
    color: '#194F47',
    fontSize: 15,
    fontWeight: 800,
  },
  cardHint: {
    margin: '4px 0 0',
    color: '#718396',
    fontSize: 13,
    lineHeight: 1.5,
  },
  accessBadge: {
    flex: '0 0 auto',
    padding: '7px 11px',
    borderRadius: 999,
    color: '#176B5B',
    background: 'linear-gradient(135deg, #EAF8F2 0%, #E8F7F6 100%)',
    border: '1px solid #B9DDD2',
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '0.055em',
    textTransform: 'uppercase',
  },
  nameLink: {
    display: 'block',
    width: '100%',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    color: '#176B5B',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    fontSize: 'inherit',
    fontWeight: 700,
    textDecoration: 'underline',
    textDecorationColor: 'rgba(23, 107, 91, 0.42)',
    textDecorationThickness: '1px',
    textUnderlineOffset: '2px',
    cursor: 'pointer',

    '&:hover': {
      color: '#0F5B4D',
      textDecorationColor: '#0F5B4D',
    },
  },
  officeCell: {
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
  },
  addressCell: {
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
  },
  emailCell: {
    display: 'inline-block',
    width: 'auto',
    minWidth: 'max-content',
    maxWidth: 'none',
    overflow: 'visible',
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 0,
    textOverflow: 'clip',
    whiteSpace: 'nowrap',
    overflowWrap: 'normal',
    wordBreak: 'normal',
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
    width: '100%',
    minWidth: 0,
    maxWidth: 86,
    padding: '5px 6px',
    boxSizing: 'border-box',
    borderRadius: 999,
    fontSize: 9.5,
    fontWeight: 800,
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
  statusActive: {
    color: '#0D6B4B',
    background: 'linear-gradient(135deg, #DCF8EB 0%, #CFF2E3 100%)',
    border: '1px solid #A9DEC8',
    boxShadow: '0 4px 10px rgba(13, 107, 75, 0.10)',
  },
  statusInactive: {
    color: '#5C6470',
    background: 'linear-gradient(135deg, #F2F4F7 0%, #E7EBF0 100%)',
    border: '1px solid #D2D9E1',
  },
  statusDot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    background: 'currentColor',
  },
  loadingScreen: {
    position: 'fixed',
    top: 72,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    background: '#ffffff',
  },
  loadingLogoWrap: {
    width: 'min(680px, 62vw)',
    maxWidth: 'calc(100vw - 48px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [muiTheme.breakpoints.down('sm')]: {
      width: 'min(520px, 78vw)',
    },

    [muiTheme.breakpoints.down('xs')]: {
      width: 'min(390px, 86vw)',
    },
  },
  loadingLogo: {
    display: 'block',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    background: 'transparent',
    filter: 'none',
  },
  errorCard: {
    maxWidth: 600,
    margin: '70px auto',
    padding: 28,
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid #efc9c4',
    boxShadow: '0 18px 48px rgba(26, 53, 80, 0.09)',
    textAlign: 'center',
  },
  errorTitle: {
    margin: 0,
    color: '#9b3e36',
    fontSize: 20,
    fontWeight: 800,
  },
  errorText: {
    margin: '9px 0 0',
    color: '#785a58',
    fontSize: 14,
    lineHeight: 1.55,
  },
  dialogPaper: {
    borderRadius: 16,
  },
  dialogTitle: {
    color: '#243b52',
    fontWeight: 800,
  },
  dangerButton: {
    color: '#ffffff',
    background: '#b9473d',

    '&:hover': {
      background: '#9e382f',
    },
  },
}));

const DistributorList = () => {
  const classes = useStyles();
  const [data, setData] = useState({})
  const { token, authBody, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);
  const [profile, setProfile] = useState(authBody || {role: "visitor"})
  const [loading, setLoading] = useState(true)
  const hasRole = (profile, roles) =>{
    return roles.includes(profile.role)
  }

  const handleClose = () => {
    setState({...state, dialogOpen: false});
  };

  const handleSubmit = () => {
    console.log(state)
    axios({
      url: `https://${api_url}/api/reset_password?login=${state.rowData.Email_Address}`,
      method: 'post',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
        }
        else if(res.data.validation){
          alert(res.data.validation.replace("_", " "))
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
          setState({...state, dialogOpen: false})
        }
      }
    );
  }

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios({
        url: `https://${api_url}/api/distributor_list`,
        method: 'get',
        headers: {
          'x-access-token' : token
        }
      }).then(
        res => {
          if(res.data.message){
            alert(res.data.message)
          }
          else if(res.data.validation){
            alert(res.data.validation.replace("_", " "))
          }
          else if(res.data.notLoggedIn){
            setAuthenticated(false)
            setAuthBody({role: 'visitor'})
            alert("You have been logged out due to inactivity. Please log in again.")
          }
          else{
            setLoading(false)
            setState((prevState) => ({
              ...prevState, data: res.data
            }))
          }
        }
      );

    }
    fetchData();
  }, [setAuthBody, setAuthenticated, token]);

    console.log(data)

  const [state, setState] =
  useState({
    adminColumns: [
      { title: 'Company Name', field:'Office_Name', render:rowData => {
        return (
          <div>
            {rowData.Office_Name}
          </div>
        )
      }, cellStyle:{ fontSize: '.7em'}},
      { title: 'First Name', field:'First_Name', cellStyle:{ fontSize: '.7em'}},
      { title: 'Middle Name', field:'Middle_Name', cellStyle:{ fontSize: '.7em'}},
      { title: 'Last Name', field:'Last_Name', cellStyle:{ fontSize: '.7em'}},
      { title: 'Country', field:'Country', cellStyle:{ fontSize: '.7em'}},
      { title: 'City', field:'City', cellStyle:{ fontSize: '.7em'}},
      { title: 'Postal Code', field:'Postal_Code', cellStyle:{ fontSize: '.7em'}},
      { title: 'Street', field:'Street', cellStyle:{ fontSize: '.7em'}},
      { title: 'State/Province', field:'State_Province', cellStyle:{ fontSize: '.7em'}},
      { title: 'Email Address', field:'Email_Address', cellStyle:{ fontSize: '.7em'}},
      { title: 'Phone', field:'Phone', cellStyle:{ fontSize: '.7em'}},
      { title: 'Fax', field:'Fax', cellStyle:{ fontSize: '.7em'}},
      { title: 'Available', field: 'available', type: "boolean"},

    ],
    columns:[
      { title: 'Company Name', field:'Office_Name', render:rowData => {
        return (
          <div>
            <Link type="text" to={`/distributorcases/${rowData.Email_Address}`}>{rowData.Office_Name}</Link>
          </div>
        )
      }, cellStyle:{ fontSize: '.7em'}, editable: "never"},
      { title: 'First Name', field:'First_Name', cellStyle:{ fontSize: '.7em'}, editable: "never"},
      { title: 'Middle Name', field:'Middle_Name', cellStyle:{ fontSize: '.7em'}, editable: "never"},
      { title: 'Last Name', field:'Last_Name', cellStyle:{ fontSize: '.7em'}, editable: "never"},
      { title: 'Office Address', field:'Office_Address', cellStyle:{ fontSize: '.7em'}, render: rowData =>{
        return(
          <div>
            {rowData.Street} [ {rowData.City}, {rowData.Country} ]
          </div>
        )
      }, editable: "never"},
      { title: 'Email Address', field:'Email_Address', cellStyle:{ fontSize: '.7em'}, editable: "never"},
      { title: 'Phone', field:'Phone', cellStyle:{ fontSize: '.7em'}, editable: "never"},
      { title: 'Fax', field:'Fax', cellStyle:{ fontSize: '.7em'}, editable: "never"},
      { title: 'Available', field: 'available', type: "boolean"},

    ],

  })

  ;

  console.log(state)
  if(loading){
    return(
      <div id="p5_loading" className={classes.loadingScreen}>
        <div className={classes.loadingLogoWrap}>
          <img
            src={logo}
            alt="logo"
            className={classes.loadingLogo}
          />
        </div>
      </div>

    )
  }

  return(
  <ThemeProvider theme={theme}>
    <main className={classes.page}>
      <div className={classes.shell}>
        <header className={classes.pageHeader}>
          <div>
            <p className={classes.eyebrow}>Organization directory</p>
            <h1 className={classes.title}>
              {hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ? "Distributor Directory" : "Representative Directory"}
            </h1>
            <p className={classes.subtitle}></p>
          </div>

          <div className={classes.headerMeta}>
            <span className={classes.metaPill}>
              <span className={classes.metaDot} />
              {state.data ? state.data.length : 0} {state.data && state.data.length === 1 ? 'record' : 'records'}
            </span>
          </div>
        </header>

        <section className={classes.card}>
          <div className={classes.cardIntro}>
            <div>
              <p className={classes.cardLabel}>Directory records</p>
              <p className={classes.cardHint}>
                Search, sort, filter, and review account details from one place.
              </p>
            </div>
          </div>

    <MaterialTable
      title={hasRole(profile, ['super_admin', 'write_admin', 'read_admin'])?"Distributor List": "Representative List"}
      columns={hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ? state.adminColumns : state.columns}
      data={state.data}
      icons={tableIcons}
      actions={
        hasRole(profile, ['super_admin']) ?

        [{
        icon: tableIcons.Reset,
        tooltip: 'Reset Password',
        onClick: (event, rowData) => {
          setState({...state, dialogOpen: true, rowData})
        }
      }]

      :

      null
      }
      editable={
        hasRole(profile, ['super_admin']) ?
        {
        onRowUpdate: (newData, oldData) =>
           new Promise((resolve, reject) => {
             setTimeout(() => {
               {
                 const data = [...state.data];
                 const index = data.indexOf(oldData);
                 data[index] = newData;
                 axios({
                   url: `https://${api_url}/api/distributor?email=${oldData.Email_Address}`,
                   method: 'put',
                   data: newData,
                   headers: {
                     'x-access-token' : token
                   }
                 }).then(res=> {
                       if(res.data.message){
                         alert(res.data.message)
                       }
                       else if(res.data.validation){
                         alert(res.data.validation.replace("_", " "))
                       }
                       else if(res.data.notLoggedIn){
                         setAuthenticated(false)
                         setAuthBody({role: 'visitor'})
                         alert("You have been logged out due to inactivity. Please log in again.")
                       }
                       else{
                         setState({...state, data})
                       }

                   });
               }
               resolve();
             }, 1000);
           })
         }
        :
        null
      }
      localization={{
          pagination: {
              labelDisplayedRows: '{from}-{to} of {count}'
          },
          toolbar: {
              nRowsSelected: '{0} row(s) selected'
          },
          header: {
              actions: 'Edit'
          },
          body: {
              emptyDataSourceMessage: 'No records to display',
              filterRow: {
                  filterTooltip: 'Filter'
              }
          }
      }}
      options={{
        filtering: true,
        sorting: true,
        headerStyle: {
          fontSize: '.8em'
        },
        searchFieldStyle: {
          fontSize: '2rem'
        },
        pageSize: 20
      }}
      style={{
        fontSize: '20px'
      }}
      />
        </section>
      </div>
    </main>

  <Dialog open={state.dialogOpen} onClose={handleClose} aria-labelledby="form-dialog-title" PaperProps={{ className: classes.dialogPaper }}>
  <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>WARNING: RESET PASSWORD</DialogTitle>
    <DialogContent>
      <DialogContentText>
      Reset password will change for {state.rowData ? state.rowData.Office_Name : null}.
      Are you sure you want to reset this office's password?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary">
        No
      </Button>
      <Button onClick={handleSubmit} color="primary">
        Yes
      </Button>
    </DialogActions>
  </Dialog>
  </ThemeProvider>
  );
};

export default DistributorList;
